<template>
    <div class="row">
        <div class="col-sm-12">
            <form autocomplete="off" method="post" :disabled="loading" :data-vv-scope="vScope"
                @keyup.enter="() => {}"
                @submit.prevent="onBeforeSaveItem">
                <div class="row mb-3">
                    <div class="col-sm-auto">
                        <h1 class="content-title">{{ titleItem }}</h1>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-8">
                        <div class="form-group">
                            <MaterialSelect
                                :disabled="readonlyFormItem"
                                class="city-form-group city-bg"
                                id="input-layer_id"
                                name="layer_id"
                                label="name"
                                :filterable="true"
                                :options="groups"
                                v-model.trim="form.layer_id"
                                :indentText="true"
                                indentationTarget="layer_id"
                                :data-vv-scope="vScope"
                                v-validate="{required: isLayer}"
                                :inputClasses="[{'is-invalid': fnHasError('layer_id', vScope) }]"
                                :error="fnFirstError('layer_id', vScope)"
                                :helpText="`${helpTranslateID}.group`">
                                {{ $t(`${modelTranslateID}.group`) }}
                            </MaterialSelect>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <div class="form-group">
                            <MaterialSelect
                                :disabled="readonlyFormItem"
                                class="city-form-group city-bg"
                                id="input-active"
                                name="active"
                                label="name"
                                :filterable="true"
                                :options="lists.onoff"
                                v-model.trim="form.active"
                                :reduce="option => option.code"
                                :data-vv-scope="vScope"
                                v-validate="'required'"
                                :inputClasses="[{'is-invalid': fnHasError('active', vScope) }]"
                                :error="fnFirstError('active', vScope)"
                                :helpText="`${helpTranslateID}.active`">
                                {{ $t(`${modelTranslateID}.active`) }}
                            </MaterialSelect>
                        </div>
                    </div>
                    <!-- <div class="col-sm-2">
                        <div class="form-group">
                            <MaterialSelect
                                :disabled="readonlyFormItem"
                                class="city-form-group city-bg"
                                id="input-private"
                                name="private"
                                label="name"
                                :filterable="true"
                                :options="lists.onoff"
                                v-model.trim="form.private"
                                :reduce="option => option.code"
                                v-validate="{required:form.layer_id!=null}"
                                :data-vv-scope="vScope"
                                :inputClasses="[{'is-invalid': fnHasError('private', vScope) }]"
                                :error="fnFirstError('private', vScope)"
                                :helpText="`${helpTranslateID}.private`">
                                {{ $t(`${modelTranslateID}.private`) }}
                            </MaterialSelect>
                        </div>
                    </div> -->
                    <div class="col-sm-2">
                        <div class="form-group">
                            <MaterialInput
                                :readonly="readonlyFormItem"
                                type="number"
                                class="city-form-group city-bg"
                                id="input-order"
                                name="order"
                                v-model.trim="form.order"
                                :data-vv-scope="vScope"
                                v-validate="'required|integer|min_value:1'"
                                :inputClasses="[{'is-invalid': fnHasError('order', vScope) }]"
                                :error="fnFirstError('order', vScope)"
                                :helpText="`${helpTranslateID}.order`">
                                {{ $t(`${modelTranslateID}.order`) }}
                            </MaterialInput>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div v-if="!isLayer" class="col-sm-4">
                        <div class="form-group">
                            <MaterialSelect
                                :disabled="readonlyFormItem"
                                class="city-form-group city-bg"
                                id="input-collapse"
                                name="collapse"
                                label="name"
                                :filterable="true"
                                :options="lists.onoff"
                                v-model.trim="form.collapse"
                                :reduce="option => option.code"
                                v-validate="''"
                                :data-vv-scope="vScope"
                                :inputClasses="[{'is-invalid': fnHasError('collapse', vScope) }]"
                                :error="fnFirstError('collapse', vScope)" >
                                {{ $t(`${modelTranslateID}.collapse`) }}
                            </MaterialSelect>
                        </div>
                    </div>
                    <div class="" :class="[isLayer ? 'col-sm-6' : 'col-sm-8']">
                        <div class="form-group">
                            <MaterialInput
                                :readonly="readonlyFormItem"
                                type="text"
                                class="city-form-group city-bg"
                                id="input-name"
                                name="name"
                                v-model.trim="form.name"
                                v-validate="'required|min:3'"
                                :data-vv-scope="vScope"
                                :inputClasses="[{'is-invalid': fnHasError('name', vScope) }]"
                                :error="fnFirstError('name', vScope)">
                                {{ $t(`${modelTranslateID}.name`) }}
                            </MaterialInput>
                        </div>
                    </div>
                    <div v-if="isLayer" class="col-sm-3">
                        <div class="form-group">
                            <MaterialSelect
                                :disabled="readonlyFormItem"
                                class="city-form-group city-bg"
                                id="input-tiled"
                                name="tiled"
                                label="name"
                                :filterable="true"
                                :options="lists.onoff"
                                v-model.trim="form.tiled"
                                :reduce="option => option.code"
                                v-validate="{required:form.layer_id!=null}"
                                :data-vv-scope="vScope"
                                :inputClasses="[{'is-invalid': fnHasError('tiled', vScope) }]"
                                :error="fnFirstError('tiled', vScope)"
                                :helpText="`${helpTranslateID}.tiled`">
                                {{ $t(`${modelTranslateID}.tiled`) }}
                            </MaterialSelect>
                        </div>
                    </div>
                    <div  v-if="isLayer" class="col-sm-3">
                        <div class="form-group">
                            <MaterialSelect
                                :disabled="readonlyFormItem"
                                class="city-form-group city-bg"
                                id="input-visible"
                                name="visible"
                                label="name"
                                :filterable="true"
                                :options="lists.onoff"
                                v-model.trim="form.visible"
                                :reduce="option => option.code"
                                :data-vv-scope="vScope"
                                v-validate="{required:form.layer_id!=null}"
                                :inputClasses="[{'is-invalid': fnHasError('visible', vScope) }]"
                                :error="fnFirstError('visible', vScope)">
                                {{ $t(`${modelTranslateID}.visible`) }}
                            </MaterialSelect>
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="form-group">
                            <MaterialSelect
                                class="city-form-group city-bg"
                                id="input-roles"
                                name="roles"
                                :disabled="readonlyFormItem"
                                v-model.trim="form.roles"
                                :filterable="false"
                                :options="roles"
                                :reduce="reduceRole"
                                :multiple="true"
                                label="role.name"
                                v-validate="''"
                                :inputClasses="[{'is-invalid': fnHasError('roles') }]"
                                :error="fnFirstError('roles')"
                                :helpText="`${pageID}.help.roles`">
                                {{ $t(`${pageID}.model.roles`) }}
                            </MaterialSelect>
                        </div>
                    </div>
                </div>

                <div v-if="isLayer">
                    <div class="row">
                        <div class="col-12 col-sm-4">
                            <div class="form-group">
                                <h6 class="font-weight-normal">{{ $t(`${modelTranslateID}.icon`) }}</h6>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="img-icon img-thumbnail">
                                            <UploadMultipleImage
                                                :disabled="readonlyFormItem"
                                                imageClass="background-auto"
                                                name="icon_layer"
                                                v-model="icon_layer"
                                                :maxImage="1"
                                                :multiple="false"
                                                :noOverlay="true"
                                                :showImageLimitMessage="false"
                                                :data-vv-scope="vScope"
                                                v-validate="''"
                                                filenameProperty="filename"
                                                pathProperty="path"
                                                :typeProperty="null"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-8">
                            <div class="form-group">
                                <h6 class="font-weight-normal">{{ $t(`${modelTranslateID}.attribution`) }}</h6>
                                <template v-if="readonlyFormItem">
                                    <div v-html="form.attribution"></div>
                                </template>
                                <template v-else>
                                    <div class="city-form-group" :class="{'is-invalid': fnHasError('attribution', vScope) }">
                                        <ckeditor
                                            name="attribution"
                                            v-model="form.attribution"
                                            :disabled="readonlyFormItem"
                                            :editor="cKEditor.editor"
                                            :config="cKEditor.editorConfig"
                                            :data-vv-scope="vScope"
                                            v-validate="'min:3'">
                                        </ckeditor>
                                        <small v-if="fnFirstError('attribution')" class="d-block invalid-feedback">{{ fnFirstError('attribution', vScope) }}</small>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>

                    <!-- LEGEND -->
                    <LayerLegend
                        class="mt-3 mt-sm-0"
                        v-model="form"
                        :files.sync="legend_layer"
                        :idPanel="pageID"
                        :panelCfg="panelCfg"
                        :baseTranslateID="pageID"
                        :vScope="vScope"
                        :readonlyForm="readonlyFormItem"
                    />

                    <!-- FEATURE INFO -->
                    <LayerFeatureinfoForm
                        v-if="enableFeatureinfo"
                        class="mt-3"
                        v-model="form.feature_info"
                        :idPanel="pageID"
                        :panelCfg="panelCfg"
                        :baseTranslateID="pageID"
                        :vScope="vScope"
                        :readonlyForm="readonlyFormItem"
                        :resources="form.resources"
                        :formats="lists.featureinfoformats"
                    />

                    <!-- FEATUREABLE -->
                    <LayerFeatureableForm
                        v-if="enableFeatureable && form.featureable"
                        class="mt-3"
                        v-model="form.featureable"
                        :idPanel="pageID"
                        :panelCfg="panelCfg"
                        :baseTranslateID="pageID"
                        :vScope="vScope"
                        :readonlyForm="readonlyFormItem"
                        :resources="form.resources"
                        :acls="lists.featureableacls"
                        :subtypes="lists.featureablesubtypes"
                    />

                    <!-- TEMA -->
                    <LayerResources
                        class="mt-3"
                        v-model="form.resources"
                        :loadResources="loadResources"
                        :idPanel="pageID"
                        :panelCfg="panelCfg"
                        :baseTranslateID="pageID"
                        :vScope="vScope"
                        :readonlyForm="readonlyFormItem"
                    />

                </div>
                <div class="row" v-else>
                    <div class="col-sm-3">
                        <div class="form-group">
                            <MaterialColorPicker
                                :disabled="readonlyFormItem"
                                class="city-form-group city-bg"
                                id="input-icon_bg_color"
                                name="icon_bg_color"
                                v-model.trim="form.icon_bg_color"
                                :data-vv-scope="vScope"
                                v-validate="{required:!form.layer_id}"
                                :inputClasses="[{'is-invalid': fnHasError('icon_bg_color', vScope) }]"
                                :error="fnFirstError('icon_bg_color', vScope)"
                                :helpText="`${helpTranslateID}.icon_bg_color`">
                                {{ $t(`${modelTranslateID}.icon_bg_color`) }}
                            </MaterialColorPicker>
                        </div>
                    </div>
                    <div class="col-sm-9">
                        <div class="form-group">
                            <MaterialInput
                                :disabled="readonlyFormItem"
                                type="text"
                                class="city-form-group city-bg"
                                id="input-icon"
                                name="icon"
                                v-model.trim="form.icon"
                                :data-vv-scope="vScope"
                                v-validate="{required:!form.layer_id}"
                                :inputClasses="[{'is-invalid': fnHasError('icon', vScope) }]"
                                :error="fnFirstError('icon', vScope)"
                                :helpText="`${helpTranslateID}.icon`">
                                {{ $t(`${modelTranslateID}.icon`) }}
                            </MaterialInput>
                        </div>
                    </div>
                </div>

                <buttons-footer
                    :enableButtons="!readonlyFormItem"
                    :cancelTitle="cancelTitle"
                    :submitTitle="submitTitle"
                    :isDisabled="isDisabled"
                    @save="onBeforeSaveItem"
                    @cancel="handleBack(`${moduleCode}.${pageID}`, true)">
                </buttons-footer>
            </form>

        </div>
    </div>
</template>

<script>
    import DetailsMixin from './mixins/DetailsMixin';
    import CkEditorConfigMixin from '@/app/shared/mixins/ckeditor/BaseCkEditorConfigMixin';

    export default {
        name: 'LayerDetails',
        components: {
            ResourceItemList: () => import(/* webpackChunkName: "ogc-resourceitemlist" */ '@/app/shared/components/ogc/resource/ResourceItemList'),
            ResourceItemSelected: () => import(/* webpackChunkName: "ogc-resourceitemselected" */ '@/app/shared/components/ogc/resource/ResourceItemSelected'),
            LayerResources: () => import(/* webpackChunkName: "recursive-details-layer-resources" */ './elements/LayerResources'),
            LayerLegend: () => import(/* webpackChunkName: "recursive-details-layer-legend" */ './elements/LayerLegend'),
            LayerFeatureinfoForm: () => import(/* webpackChunkName: "recursive-details-layer-featureinfoform" */ './elements/LayerFeatureinfoForm'),
            LayerFeatureableForm: () => import(/* webpackChunkName: "recursive-details-layer-featureableform" */ './elements/LayerFeatureableForm'),
        },
        provide () {
            return { parentValidator: this.$validator }
        },
        mixins: [
            DetailsMixin,
            CkEditorConfigMixin,
        ],
        props: {
        },
        data() {
            return {
                pageID: 'layers',
                pageTitle: 'Camadas',
                vScope: 'form',
                form: {
                    id: null,
                    behavior: null,
                    layer_id: null,
                    name: null,
                    filter: null,
                    collapse: true,
                    active: true,
                    visible: false,
                    private: false,
                    order: 1,
                    icon_bg_color: null,
                    icon: null,
                    legend_automatic: false,
                    icon_layer: [],
                    legend_layer: [],
                    feature_info: {
                        id: null,
                        queryable: false,
                        format: 'TEXT',
                        collapsible: false,
                        params: null,
                        styles: null,
                        typenames: [],
                    },
                    resources: [],
                    attribution: null,
                    tiled: true,
                    featureable: {
                        id: null,
                        status: false,
                        integration_id: null,
                        acl_code: null,
                        typenames: [],
                    },
                    roles: []
                },
                icon_layer: [],
                legend_layer: [],
                toolbarType: 'basic',
                lists: {
                    featureable: false,
                    featureinfoformats: [],
                    featureableacls: [],
                    featureablesubtypes: [],
                    roles: [],
                },
            }
        },
        computed: {
            enableFeatureinfo() {
                return !!this.form.feature_info;
            },
            panelCfg() {
                return this.panel ?? {};
            },
            enableFeatureable() {
                return this.lists.featureable ?? false;
            },
            roles() {
                return this.lists.roles.map(r => {
                    return {
                        role_id: r.id,
                        role: r,
                    }
                });
            }
        },
        methods: {
            onChangeServerType() {
                if(!this.form.server_type_id){
                    this.form.ogc_internal = null;
                    this.form.ogc_internal_server_id = null;
                    this.form.url = null;
                    this.form.service_id = null;
                    this.form.service_version_id = null;
                    this.form.layers = null;
                    //this.resetValidator();
                }
            },
            onChangeOGCInternal() {
                if(this.form.ogc_internal==null){
                    this.form.ogc_internal_server_id = null;
                    this.form.service_id = null;
                    this.form.service_version_id = null;
                    this.form.layers = null;
                    //this.resetValidator();
                }
                this.form.url = this.form.ogc_internal ? null : this.form.url;
            },
            onChangeService() {
                if(!this.form.service_id){
                    this.form.layers = null;
                    //this.resetValidator();
                }
            },
            onBeforeSaveItem() {
                if(!this.isLayer){
                    this.form.feature_info = null;
                    this.form.featureable = null;
                }
                this.saveItemOldWay(`${this.moduleCode}.${this.pageID}`, ['icon_layer', 'legend_layer']);
            },
            forceDirtyUpload: function(key){
                if(this.fields.$form && this.fields.$form[key]){
                    this.fields.$form[key].dirty=true;
                }
            },
            reduceRole(option) {
                return option;
            }
        },
        watch:{
            'icon_layer': {
                handler(value, oldValue){
                    this.forceDirtyUpload('icon_layer');
                },
                deep: true,
            },
        }

    }
</script>

<style scoped lang="scss">
    .img-icon {
        height: 100%;
        min-height: 188px;
        max-width: 100%;
    }

    .flip-list-move {
        transition: transform 0.5s;
    }
    .no-move {
        transition: transform 0s;
    }
    .ghost {
        opacity: 0.5;
        background: #c8ebfb;
    }
</style>

<style lang="scss">
    .ck-editor .ck-content.ck-editor__editable {
        min-height: 150px;
    }
</style>
